document.addEventListener("DOMContentLoaded", () => {
  const layout = document.querySelector(".layout"),
    // dropdown = document.querySelector(".header__dropdown-menu"),
    burgerBtn = document.querySelector(".header__burger"),
    burgerIcon = document.querySelector(".burger-btn"),
    closeBurgerBtn = document.querySelector(".close-burger_btn"),
    menuOpen = document.querySelector(".menu__mob-opened"),
    linkMobil = document.querySelector(".menu-dropdown"),
    openSearch = document.querySelector(".header-search__icon"),
    searchInput = document.querySelector(".header-search__input"),
    closeSearch = document.querySelector(".close-search"),
    langBtn = document.querySelector(".lang-button"),
    langBlock = document.querySelector(".lang-button__dropdown"),
    html = document.querySelector("html"),
    link = document.querySelector(".header__link-styled-event"),
    links = document.querySelectorAll(".header__link-styled-event"),
    dropdown = document.querySelector(".header__dropdown-menu");

  langBtn.addEventListener("click", () => {
    langBtn.classList.toggle("lang-open");
    langBlock.style.display =
      langBlock.style.display === "block" ? "none" : "block";
  });

  burgerBtn.addEventListener("click", () => {
    document.body.classList.toggle("menu-open");
    layout.classList.toggle("layout__white");
    closeBurgerBtn.style.display =
      closeBurgerBtn.style.display === "block" ? "none" : "block";
    burgerIcon.style.display =
      burgerIcon.style.display === "none" ? "block" : "none";
    menuOpen.style.display =
      menuOpen.style.display === "block" ? "none" : "block";
  });

  linkMobil.addEventListener("click", () => {
    document.body.classList.toggle("menu-sub-open");
  });

  if (closeSearch !== null && closeSearch !== null) {
    openSearch.addEventListener("click", () => {
      layout.classList.toggle("layout__white");
      searchInput.style.top = "25px";
    });

    closeSearch.addEventListener("click", () => {
      layout.classList.toggle("layout__white");
      searchInput.style.top = "-100px";
    });
  }

  html.addEventListener("click", (e) => {
    if (e.target !== langBtn) {
      langBtn.classList.remove("lang-open");
      langBlock.style.display = "none";
      // langBlock.style.top = '-100px'
    }
  });

  if (links) {
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (e.target.parentElement.classList.contains("active_link")) {
          layout.classList.toggle("white");
          dropdown.classList.toggle("menu_active");
          const activeLI = document.querySelectorAll(
            ".header__link-styled-event.active_link"
          );
          [].forEach.call(activeLI, function (el) {
            el.classList.remove("active_link");
          });
        } else {
          const activeLI = document.querySelectorAll(
            ".header__link-styled-event.active_link"
          );
          [].forEach.call(activeLI, function (el) {
            el.classList.remove("active_link");
          });

          e.target.parentElement.classList.add("active_link");

          const html =
            e.target.parentElement.querySelector(".header_menu").innerHTML;
          const dropdownMenu = document.getElementById("dropdownMenu");
          dropdownMenu.innerHTML = html;
          if (!layout.classList.contains("white")) {
            layout.classList.toggle("white");
            dropdown.classList.toggle("menu_active");
          }
          setTimeout(function () {
            const dropdownMenu = document.getElementById("dropdownMenu");
            const dropdownMenuLi = dropdownMenu.querySelectorAll("li");
            dropdownMenuLi.forEach((li) => {
              li.classList.toggle("element-show");
            });
          }, 100);
        }
      });
    });
  }

  document.addEventListener("click", (e) => {
    let target = e.target;
    let its_menu = target == dropdown || dropdown.contains(target);
    let its_link = target == link;
    let menu_active = dropdown.classList.contains("menu_active");
    if (!its_menu && !its_link && menu_active) {
      layout.classList.toggle("white");
      dropdown.classList.toggle("menu_active");
      const activeLI = document.querySelectorAll(
        ".header__link-styled-event.active_link"
      );
      [].forEach.call(activeLI, function (el) {
        el.classList.remove("active_link");
      });
    }
  });
});
